/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JobApplication } from '../../models/job-application';

export interface GetStudentJobApplications$Params {
  profileId: string;
}

export function getStudentJobApplications(http: HttpClient, rootUrl: string, params: GetStudentJobApplications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<JobApplication>>> {
  const rb = new RequestBuilder(rootUrl, getStudentJobApplications.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<JobApplication>>;
    })
  );
}

getStudentJobApplications.PATH = '/studentprofile/{profileId}/applications';
